export class InactiveClientError extends Error {
    code: string;

    constructor(message: string) {
        super(message);
        this.name = 'InactiveClientError';
        this.code = 'auth/inactive-client';
    }
}